import { UserFacingError } from './errors'

export class EventAccessDeniedError extends UserFacingError {
  constructor() {
    super('You do not have permission to manage events for this organization.')
    this.name = 'EventAccessDeniedError'
  }
}

export class EventNotFoundError extends UserFacingError {
  constructor() {
    super('That event no longer exists.')
    this.name = 'EventNotFoundError'
  }
}

export class EventCancelledError extends UserFacingError {
  constructor() {
    super('This event has been cancelled and can no longer be edited.')
    this.name = 'EventCancelledError'
  }
}

export class CapacityBelowConfirmedError extends UserFacingError {
  constructor(message?: string) {
    super(
      message ??
        'Capacity cannot be lower than the seats already confirmed. Cancel registrations first.',
    )
    this.name = 'CapacityBelowConfirmedError'
  }
}

export class WaitlistPromotionFullError extends UserFacingError {
  constructor() {
    super('The event is full. Cancel a confirmed registration before promoting.')
    this.name = 'WaitlistPromotionFullError'
  }
}

export class EventNotModeratedError extends UserFacingError {
  constructor() {
    super('A random draw only runs on an event that approves entries manually.')
    this.name = 'EventNotModeratedError'
  }
}

export class DrawExceedsCapacityError extends UserFacingError {
  constructor() {
    super(
      'The draw would approve more seats than this event has left. Refresh the page and try a smaller number.',
    )
    this.name = 'DrawExceedsCapacityError'
  }
}
